﻿import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Fetching from "@/components/Fetching/Fetching";

import { getDashboardLast } from "@/api/Dashboard/dashboard";
import { dateToLocale, formatMilesDecimal, initialText } from "@/services/Utils";

import classes from "./dashboard-last.module.scss";

const DashboardLast = ({ filters }) => {
	const navigate = useNavigate();
	const { estate_parent_id, estate_id, type_currency } = useSelector((state) => state.auth.filter);

	const { data, isLoading } = useQuery(["dashboard_last", { ...filters, estate_parent_id, estate_id, type_currency }], () =>
		getDashboardLast({ ...filters, estate_parent_id, estate_id, type_currency }),
	);

	return (
		<>
			{isLoading ? (
				<Fetching topMargin={"5em"} bottomMargin={"5em"} />
			) : (
				<>
					<div className={classes.style_table}>
						<table className={classes.style_table_title}>
							<thead>
								<tr>
									<th className={classes.table_th} style={{ width: "30%" }}>
										Nombre
									</th>
									<th className={classes.table_th} style={{ width: "20%" }}>
										Consumo
									</th>
									<th className={classes.table_th} style={{ width: "30%" }}>
										Fecha
									</th>
									<th className={classes.table_th} style={{ width: "20%" }}>
										Operador
									</th>
								</tr>
							</thead>
						</table>
						{data &&
							data.map((item, i) => {
								return (
									<table key={i} className={classes.style_table_body}>
										<tbody>
											<tr>
												<td style={{ width: "30%" }}>{item.product}</td>
												<td style={{ width: "20%" }}>{`${formatMilesDecimal(item.weight_used)}${item.unit}`}</td>
												<td style={{ width: "30%" }}>{dateToLocale(item.date_weight)}</td>
												<td style={{ width: "20%" }}>{initialText(item.operator)}</td>
											</tr>
										</tbody>
									</table>
								);
							})}
					</div>

					<div className={classes.footer}>
						<div className={classes.footer_text} onClick={() => navigate("/historiales/usos")}>
							Ver más...
						</div>
					</div>
				</>
			)}
		</>
	);
};

export default DashboardLast;
